import type { Account } from "./Account";
import type { EquipmentType } from "./EquipmentType";
import { PendingChange } from "./PendingChange";
import { PolicyAdditionalInterest } from "./PolicyAdditionalInterest";
import { Property } from "./Property";
import { AccountEquipmentStatus } from "./Tractor";
import { User } from "./User";
import { Vehicle } from "./Vehicle";

export class BusinessAuto {
    id: number;

    createDate: Date;

    updateDate: Date;

    submit: boolean;

    isDeleted: boolean;

    accountId: string;

    year: number | null;

    make: string | null;

    typeId: EquipmentType["id"];

    type: EquipmentType;

    vin: string | null;

    acv: boolean;

    value: number | null;

    comprehensive: boolean;

    collision: boolean;

    ownerOperator: boolean;

    vinValid: number | null;

    comments: string | null;

    createdByWaypointUserId: string;

    unitNumber: string | null;

    account?: Account;

    additionalInterests?: PolicyAdditionalInterest[];

    createdByGuid: string;

    createdBy: User;

    propertyId: number;

    property?: Property;
    pendingChanges?: PendingChange[];

    policyUpcomingDate?: string | null | undefined;
    policyUpcomingChange?: "add" | "change" | "remove" | null | undefined;
    policyValue?: number | null | undefined;
    policyOwnerOperator?: boolean | null | undefined;
    policyAcv?: boolean | null | undefined;
    policyComprehensive?: boolean | null | undefined;
    policyCollision?: boolean | null | undefined;
    statuses?: AccountEquipmentStatus[];
    coverages?: { policyId: string; coverageOptionId: number; effectiveDate: string; isUpcoming: boolean }[];

    toString(): string {
        return Vehicle.toString(this);
    }
}
